import React, { useEffect } from "react";
import "./noticiasView.css";
import { motion } from "framer-motion";

function Noticiasview() {
  useEffect(() => {
    window.scroll(0, 0);
    document.title = "Noticias | Sebas Sotelo";
  }, []);

  return (
    <div className="noticiasView__container">
      <div className="noticiasView__container__header">
        <h2 className="noticiasView__h2">Noticias</h2>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        style={{ width: "100%" }}
      >
        <div className="noticiasView__noticias">
          <p>Esta sección interna está deshabilitada.</p>
        </div>
      </motion.div>
    </div>
  );
}

export default Noticiasview;
